// Auto-save voor persoonlijke scenario's en bijhouden van het laatst
// actieve scenario voor herlaad-gedrag.
//
// We subscriben op de store en doen twee dingen:
//   1. Bij elke scenario-wijziging schrijven we (gedebounced) het
//      persoonlijke scenario terug naar IndexedDB. Publieke scenario's
//      bewerk je niet lokaal — die gaan via de "publiceer"-actie.
//   2. Bij elke scenario.id-wijziging onthouden we de id in localStorage
//      zodat de volgende sessie automatisch teruggaat naar dat scenario.

import { useStore } from "./store";
import { savePersonalScenario } from "../storage/personalScenarios";

const DEBOUNCE_MS = 500;
const LAST_SCENARIO_KEY = "schaduwtool.lastScenarioId";

export function startAutoSave(): () => void {
  let timer: ReturnType<typeof setTimeout> | null = null;

  const unsub = useStore.subscribe((state, prev) => {
    // Onthoud welk scenario actief is — voor de boot-flow van de volgende
    // sessie. Een leeg "Nieuw scenario" zonder blokken slaan we niet op.
    if (state.scenario.id !== prev.scenario.id) {
      try {
        if (state.scenario.blocks.length > 0) {
          localStorage.setItem(LAST_SCENARIO_KEY, state.scenario.id);
        } else {
          localStorage.removeItem(LAST_SCENARIO_KEY);
        }
      } catch {
        // privé-modus etc. — niet kritisch
      }
    }

    if (state.scenario === prev.scenario) return;
    if (state.scenario.isPublic) return; // alleen persoonlijke
    if (timer) clearTimeout(timer);
    timer = setTimeout(async () => {
      timer = null;
      const current = useStore.getState().scenario;
      if (current.isPublic) return;
      await savePersonalScenario(current);
      try {
        if (current.blocks.length > 0) {
          localStorage.setItem(LAST_SCENARIO_KEY, current.id);
        }
      } catch {
        // ignore
      }
      // Houdt de zichtbare lijst gesynchroniseerd zodat de net-aangemaakte
      // entry verschijnt in het scenario-menu.
      await useStore.getState().refreshPersonalList();
    }, DEBOUNCE_MS);
  });

  return () => {
    if (timer) clearTimeout(timer);
    unsub();
  };
}
